// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Ep-z","itemsContainer":"Fp-z"};